export const Style = {
  '& .dashboard-mini-card-container': {
    width: '16.6875rem',
    height: '11.1875rem',
    border: '1px solid #C9C5CA',
    borderRadius: '0.5125rem',
    padding: '1.75rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: '0.3rem 0'
  },
  '& .dashboard-atag-text': {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    cursor: 'pointer',
    flexGrow: 0
    // marginTop: '1rem'
  },
  '& .dashboard-heading': {
    fontStyle: 'normal',
    fontWeight: 550,
    fontSize: '1rem',
    lineHeight: '24px'
  },
  '& .dashboard-quantity': {
    fontStyle: 'normal',
    fontSize: '2.8125rem !important',
    lineHeight: '3.25rem'
    // marginTop: '1rem'
  }
};
